// extracted by mini-css-extract-plugin
export default {"img1":"Container2Div_img1__4n0F4","text2":"Container2Div_text2__5h-tf","img2":"Container2Div_img2__HlMMs","know_more":"Container2Div_know_more__7wjEv"};